var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53026 6.28026C5.38962 6.42087 5.19889 6.49985 5.00001 6.49985C4.80114 6.49985 4.61041 6.42087 4.46976 6.28026L0.227013 2.03751C0.155381 1.96833 0.0982438 1.88557 0.058937 1.79407C0.0196303 1.70256 -0.00105945 1.60415 -0.00192481 1.50456C-0.00279017 1.40498 0.0161863 1.30622 0.053897 1.21405C0.0916076 1.12188 0.147297 1.03814 0.217717 0.967717C0.288137 0.897297 0.371875 0.841607 0.464047 0.803897C0.55622 0.766186 0.65498 0.74721 0.754564 0.748075C0.854149 0.748941 0.952563 0.76963 1.04407 0.808937C1.13557 0.848244 1.21833 0.90538 1.28751 0.977013L5.00001 4.68951L8.71251 0.977013C8.85397 0.840394 9.04342 0.764799 9.24006 0.766507C9.43671 0.768216 9.62482 0.847093 9.76388 0.986149C9.90293 1.1252 9.98181 1.31331 9.98352 1.50996C9.98523 1.70661 9.90963 1.89606 9.77301 2.03751L5.53026 6.28026Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/drop_down_icon.b82337e28593fe73f94227377032d9f5.svg";
export { ForwardRef as ReactComponent };